import { HttpStatusError } from 'src/domain/errors/HttpStatusError';
import type { ErrorResponse } from 'src/infrastructure/rest-api/api-types';

export function isErrorResponse(body: unknown): body is ErrorResponse {
    return (
        body !== null &&
        typeof body === 'object' &&
        'message' in body &&
        'errorType' in body &&
        typeof body.errorType === 'string' &&
        'statusCode' in body &&
        typeof body.statusCode === 'number'
    );
}

export function isHttpStatusError(error: unknown): error is HttpStatusError {
    return error instanceof HttpStatusError;
}

export function isClientError(error: unknown): error is HttpStatusError {
    return isHttpStatusError(error) && error.status >= 400 && error.status < 500;
}

export function getErrorMessage(error: unknown, defaultErrorMessage?: string): string {
    if (isClientError(error)) {
        if (isErrorResponse(error.body) && typeof error.body.message === 'string') {
            const backendMsg = `${error.body.errorType}: ${error.body.message}`;
            return defaultErrorMessage ? `${defaultErrorMessage}\n${backendMsg}` : backendMsg;
        } else if (typeof error.body === 'string') {
            return defaultErrorMessage ? `${defaultErrorMessage}\n${error.body}` : error.body;
        }
    }
    return defaultErrorMessage ?? 'An unknown error occurred';
}
